import React, { useRef, useState } from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react';
import { charactersStore } from 'stores';
import useClickOutside, { DatePicker } from './datePicker';
import InfiniteCarousel from './Slider';

import './Dashboard.scss';
import {ICharacterDto} from "../../../../shared/interfaces";




export interface ILevel {
    recordId: string;
    level: string;
    createdAt?: string;
    typeEx?: string;
    name?: string;
}

export interface IDashboard {
    showHelp: boolean;
    currentStep: number;
    selectedCharacter: ICharacterDto;
    currentData: string;
    currentLevel: string;
    setCurrentLevel: (lvl: string) => void;
    setCurrentData: (data: string) => void;

    // 🔹 добавляем коллбек выбора уровня
    onLevelSelect?: (level: ILevel) => void;
}
const Dashboard: React.FC<IDashboard> = observer(
    ({ showHelp, currentStep, selectedCharacter, currentData, currentLevel, setCurrentLevel, setCurrentData }) => {
        const [open, setOpen] = useState(false);
        const modalRef = useRef<HTMLDivElement>(null);
        useClickOutside(modalRef, () => setOpen(false));

        const getPortraitImage = () => {
            if (!selectedCharacter) return '/images/no-portrait.png';
            let portrait = selectedCharacter.portrait || selectedCharacter.image || '';
            if (!portrait) return '/images/no-portrait.png';
            if (!portrait.startsWith('/')) portrait = `/images/${portrait}.png`;
            return portrait;
        };

        return (
            <div className="dashboard">
                {/* Слайдер данных (например, motion) */}


                {/* Информация о персонаже */}
                {selectedCharacter && (
                    <div className={`dashboard__character ${showHelp && currentStep !== 1 ? 'showBlur' : ''}`}>
                        <img
                            src={getPortraitImage()}
                            alt={selectedCharacter.name}
                            style={{ width: 100, height: 100, borderRadius: 8, objectFit: 'cover' }}
                        />
                        <span className="dashboard__character-name">{selectedCharacter.name}</span>
                        <div>Уровень: {currentLevel}</div>
                    </div>
                )}

                {/* Даты */}
                <div className={`dashboard__dates ${showHelp && currentStep !== 1 ? 'showBlur' : ''}`}>
                    <span>Дата:</span>
                    <span
                        className="dashboard__date-current"
                        onClick={() => setOpen(!open)}
                        style={{ cursor: 'pointer', fontWeight: 'bold' }}
                    >
                        {currentData === 'first'
                            ? 'Первая'
                            : currentData === 'midle'
                                ? 'Средняя'
                                : currentData === 'last'
                                    ? 'Последняя'
                                    : currentData}
                    </span>
                    {open && (
                        <div className="dashboard__date-menu" ref={modalRef}>

                        </div>
                    )}
                    <div className="dashboard__date-buttons">
                        <Button variant="outlined" onClick={() => setCurrentData('first')}>
                            Первая
                        </Button>
                        <Button variant="outlined" onClick={() => setCurrentData('midle')}>
                            Средняя
                        </Button>
                        <Button variant="outlined" onClick={() => setCurrentData('last')}>
                            Последняя
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
);

export default Dashboard;
